import { Stack, Typography } from "@mui/material"
import { useTranslate } from "react-admin"
import InvoiceChildrenList from "../invoiceCorrelations/InvoiceChildrenList"

const ChildDocuments = () => {
  const translate = useTranslate()

  return (
    <Stack width={"100%"} spacing={2}>
      <Typography variant="h6">
        {translate("resources.invoices.childDocuments")}:
      </Typography>
      <InvoiceChildrenList />
    </Stack>
  )
}

export default ChildDocuments